// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3rEnLlNY7dmge-Kz0uli3o"};